import { UK_COUNTRY_SUFFIX } from "./constants";

export const formatLocationLabel = (locationText: string): string =>
  locationText.replace(UK_COUNTRY_SUFFIX, "");
